import { IChartContainer } from "../models/base/chart-container.interface";
import { SwingExitModel } from "../models/smart-risk-level/swing-exit.model";
import { IComponent } from "./component.interface";

export class DrawSwingExitComponent implements IComponent {
    public id = '';

    private base: IChartContainer;
    private model = new SwingExitModel();
    private element: HTMLElement;

    constructor(element: HTMLElement, base: IChartContainer) {
        this.id = 'swing-exit';
        this.element = element;
        this.base = base;
        this.base.tiChartSeries?.subscribeExtremeChange(() => {
            setTimeout(() => {
                this.draw();
            }, 50);
        });
        this.subscribeSwingExitData();
    }

    public remove() {
        this.removeStyle();
        this.element.findFirst('.swing-exit')?.addClass('hidden');
        const yAxis: any = this.base.tiChartSeries?.highStockChart?.yAxis?.[0];
        if (!yAxis) {
            return;
        }

        yAxis.removePlotLine(this.id);
    }

    private subscribeSwingExitData() {
        this.base.chartService.subscribeSwingExitData((model: SwingExitModel) => {
            this.model = model;
            this.draw();
        });
    }

    private removeStyle() {
        const highChartStyle = this.base.tiChartSeries?.element?.findFirst('.style-' + this.id);
        if (highChartStyle) {
            highChartStyle.remove();
        }
    }

    private createSytle() {
        this.removeStyle();
        const className = this.id;
        let styleTag = `<style>`;

        styleTag += `.highcharts-plot-line.${className} {stroke: ${this.model.swingExitColor.toRGB()}; stroke-dasharray: 3, 2;}`;

        styleTag += `</style>`;

        const chartStyleContainer = `<div class="style-${className}">${styleTag}</div>`;
        this.base.tiChartSeries?.element.insertAdjacentHTML('afterbegin', chartStyleContainer);
    }

    private draw() {
        this.remove();
        const yAxis: any = this.base.tiChartSeries?.highStockChart?.yAxis?.[0];
        if (!yAxis || !this.model.show) {
            return;
        }

        this.createSytle();
        yAxis.addPlotLine({
            value: this.model.swingExit,
            className: this.id,
            width: 1,
            id: this.id,
            zIndex: 10
        });

        this.setYAxisLabelPosition();
    }

    private setYAxisLabelPosition() {
        const yAxis = this.base.tiChartSeries?.highStockChart?.yAxis?.[0];
        if (!yAxis || !this.model.show) {
            return;
        }

        const textElement = this.element.findFirst('.swing-exit');
        if (!textElement) {
            return;
        }

        const plotLine = this.base.tiChartSeries.element.findFirst('.highcharts-plot-line.swing-exit');
        if (!plotLine || !plotLine.getAttribute('d')) {
            textElement.addClass('hidden');
        } else {
            const extraTop = 30 + (this.base.tiChartSeries?.hasAnyComparisonSymbols() ? 20 : 0);
            const top = yAxis.toPixels(this.model.swingExit, true);
            textElement.style.top = (top + extraTop) + 'px';
            textElement.style.borderColor = this.model.swingExitColor.toRGB();    
            plotLine.setAttribute('title', this.model.tooltip);
            textElement.removeClass('hidden');
        }
    }
}